import { IMessage, IQuoteableCarriersProduct } from '@boldpenguin/sdk-types';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAnswer, IApplication, IQuestion, IQuestionSet } from 'src/app/models/application-form/application-form.model';

export abstract class ApplicationFormAbstractService {
  abstract get activeQuestionSet$(): BehaviorSubject<IQuestionSet>;
  abstract get activeQuestionComplete$(): BehaviorSubject<boolean>;
  abstract get quoteRequests$(): BehaviorSubject<any[]>;
  abstract get isAppFormRedirected$(): BehaviorSubject<boolean>;
  abstract get isAppSyncedWithBP$(): BehaviorSubject<boolean>;
  abstract get application$(): BehaviorSubject<IApplication>;
  abstract get appFormState$(): BehaviorSubject<string>;
  abstract get isActiveQuestionSetLoading$(): BehaviorSubject<boolean>;
  abstract get isSDKAppFormLoading$(): BehaviorSubject<boolean>;
  abstract get areQuotesLoading$(): BehaviorSubject<boolean>;
  abstract get isBridgingToSDKQSet$(): Observable<boolean>;
  abstract get isOwner$(): Observable<boolean>;
  abstract get isLocked$(): Observable<boolean>;
  abstract get isTakenOver$(): Observable<boolean>;
  abstract get isFormCloned$(): Observable<boolean>;
  abstract get isFormInactive$(): Observable<boolean>;
  abstract get isFormLoaded$(): Observable<boolean>;
  abstract get isEOMLoading$(): Observable<boolean>;
  abstract get getMessages$(): Observable<IMessage[]>;
  abstract get isTakingOver(): boolean;
  abstract get carrierProducts$(): Observable<IQuoteableCarriersProduct[]>;
  abstract get isReferred(): boolean;
  abstract isInTransition: boolean;
  abstract dashboardFlag: boolean;
  abstract searchPageUser: string;
  abstract searchPageGUID: string;
  abstract readOnlyMode$: BehaviorSubject<boolean>;
  abstract createNewApplication(): void;
  abstract loadSdkApplication(isPrefill?: boolean): void;
  abstract getQuestionSet(code: string): IQuestionSet;
  abstract getQuestionByCode(code: string): IQuestion;
  abstract getAnswerByCode(code: string): IAnswer;
  abstract saveQuestionSet(): void;
  abstract changeActiveQuestionSet(routeOrder: number, routId?: string): void;
  abstract updateAnswer(answer: IAnswer): void;
  abstract updateBusinessInfoState(): void;
  abstract resetSdkApplicationForm(): void;
  abstract subscribeControlToFocus(): void;
  abstract bindQuote(appFormId: string, quoteId: string): Observable<string>;
  abstract cloneApplicationForm(params: any): void;
  abstract saveBusinessInfoQSet(): void;
  abstract exploreOtherMarkets(): void;
  abstract get riskCode(): string;
  abstract get quoteNumber(): string;
  abstract get stateCode(): string;
}
